import { Dispatch } from 'redux'

import * as Api from 'redux/api/Admin/authentication/v1'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { useThunkActions } from 'redux/actions/useThunkActions'

import { SnackbarMessage } from 'types/GlobalSnackbar'
import { TAzureAdBody } from 'types/GlobalAuthentication'

import * as actions from './actions'

export function tryGetAzureAd() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAzureAd())

    Api.getAzureAd()
      .then((response) => {
        dispatch(actions.getAzureAdSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getAzureAdFailed())
      })
  }
}

export function tryPutAzureAd(body: TAzureAdBody) {
  return (dispatch: Dispatch) => {
    dispatch(actions.putAzureAd())

    Api.putAzureAd(body)
      .then((response) => {
        dispatch(actions.putAzureAdSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.putAzureAdFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export function tryDeleteAzureAd() {
  return (dispatch: Dispatch) => {
    dispatch(actions.deleteAzureAd())

    Api.deleteAzureAd()
      .then(() => {
        dispatch(actions.deleteAzureAdSuccess())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.deleteAzureAdFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export const useAdminAuthenticationActions = () => {
  return {
    tryGetAzureAd: useThunkActions(tryGetAzureAd),
    tryPutAzureAd: useThunkActions(tryPutAzureAd),
    tryDeleteAzureAd: useThunkActions(tryDeleteAzureAd)
  }
}
